'use client'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { Body, List, ListItem, SectionHeader } from './ui'

const ns = 'SumitomoTermsPoints'

export const SumitomoTermsPoints = () => {
  return (
    <Body>
      <SectionHeader>
        <FormattedMessage id={`${ns}.reviewHeader`} />
      </SectionHeader>
      <List>
        <ListItem>
          <FormattedMessage id={`${ns}.shipsFromJapan`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.freightForwarder`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.importDuties`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.radioCertification`} />
        </ListItem>
      </List>

      <SectionHeader>
        <FormattedMessage id={`${ns}.confirmHeader`} />
      </SectionHeader>
      <List>
        <ListItem>
          <FormattedMessage id={`${ns}.registeredBusiness`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.commercialUse`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.exportCompliance`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.noReexport`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.radioResponsibility`} />
        </ListItem>
      </List>
    </Body>
  )
}
